<template>
  <div id="hammocks">
    <div id="hammocks-header">
      <h1>{{text}}</h1>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      
    }
  },
  computed: {
    text () {
      var newYears = new Date("Dec 31, 2019 13:00:00").getTime();
      var now = new Date().getTime();
      var delta = newYears - now;
      var days = Math.ceil(delta / 86400000);
      var hours = Math.ceil((delta % 86400000)/3600000)
      if (delta < 0){
        return "Nå henger vi sammen som mann og kone"; 
      } else if (delta < 86400000){
        return "Kun " + hours + " timer til vi henger sammen som mann og kone";
      } else {
        return "Kun " + days + " dager til vi henger sammen som mann og kone";
      }
    }
  },
  methods: {
    
  }  
}
</script>

<style lang="scss">

  #hammocks {
    background-position: center;
    background-image: url("../assets/hammock.jpg");
    background-size: cover;
    border-bottom-color: rgb(0, 0, 0);
    border-bottom-width: 10px;
    position: relative;
    height: 100vh;
    width: 100%;
    z-index: 5;
    overflow: hidden;

  }
  #hammocks-header {
    text-align: center;
    position: absolute;
    bottom: 0;
    width: 60vw;
    left: calc(20% - 5px); 
    @media screen and (max-width: 900px){
      width: 100%;
      left: 0;
    }
    background-image: linear-gradient(to top, rgba(185, 185, 185, 0.849),rgba(180, 180, 180, 0.699), rgba(179, 179, 179, 0));

    & > h1 {
      margin-top: 5%;
      margin-bottom: 2%;
      font-size: calc(0.75em + 3.4vw);
      font-family: 'Shadows Into Light';
      color: rgb(0, 0, 0);
      line-height: 120%;
      @media screen and (max-width: 900px){
        font-size: calc(1.2em + 6vw);
      }
    }
  }
</style>
